export const projects = [
  {
    title: "JamSpace",
    description: "Online marketplace that connects people with musical instruments they want to rent out to people who want to rent instruments.", 
    techStack: ["Featured", "MongoDB", "Express", "React", "Node.js", "Bootstrap", "MUI", "API"],
    githubLink: "https://noahthomlison.github.io/JamSpace/",
    image: ["../projectImages&Gifs/Fullsize/JamSpace.gif"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/JamSpace Small.gif"]
  },
  {
    title: "TinyApp ",
    description: "TinyApp is a full stack web application built with Node and Express that allows users to shorten long URLs", 
    techStack: ["JS", "Express", "Node.js", "EJS"],
    githubLink: "https://noahthomlison.github.io/tinyapp/",
    image: ["./projectImages&Gifs/Fullsize/TinyApp.gif"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/TinyApp Small.gif"]
  },
  {
    title: "Jungle",
    description: "A mini e-commerce application built with Rails 4.2 for purposes of teaching Rails by example. ", 
    techStack: ["Ruby", "Rails", "PostgreSQL", "ActiveRecord"],
    githubLink: "https://noahthomlison.github.io/jungle-rails/",
    image: ["./projectImages&Gifs/Fullsize/Jungle.gif"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/Jungle Small.gif"]
  },
  {
    title: "Tweeter",
    description: "Tweeter is a simple, single-page Twitter clone. ", 
    techStack: ["HTML", "CSS", "JS", "jQuery", "Ajax", "Node.js", "Express", "MongoDB"],
    githubLink: "https://noahthomlison.github.io/tweeter/",
    image: ["./projectImages&Gifs/Fullsize/Tweeter.gif"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/Tweeter Small.gif"]
  },
  {
    title: "LightBnB",
    description: "LightBNB is an Lighthouse Labs AirBNB clone", 
    techStack: ["JS", "SASS", "Node.js", "Express", "PostgreSQL"],
    githubLink: "https://noahthomlison.github.io/LightBnB/",
    image: ["./projectImages&Gifs/Fullsize/LightBNB.gif"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/LightBNB Small.gif"]
  },
  {
    title: "Scheduler",
    description: "Interview Scheduler is a single-page application (SPA) that allows users to book technical interviews between students and mentors.", 
    techStack: ["Featured", "React", "Cypress", "Storybook", "Jest", "Express"],
    githubLink: "https://github.com/NoahThomlison/scheduler",
    image: ["./projectImages&Gifs/Fullsize/Scheduler.gif"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/Scheduler Small.gif"]
  },
  {
    title: "Smart-To-Do-List",
    description: "The Smart To Do List is a self sorting to do list where a user can enter a keyword/task and the app will sort it into a predefined category", 
    techStack: ["Featured", "JS", "EJS", "Express", "Node.js", "API"],
    githubLink: "https://github.com/NoahThomlison/SmartToDoList",
    image: ["./projectImages&Gifs/Fullsize/Smart-To-Do-List.png"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/Smart-To-Do-List.png"]
  },
  {
    title: "MiniProject - Tours",
    description: "Tours are generated from an API, user can expand for more information or delete from list", 
    techStack: ["React", "API"],
    githubLink: "https://github.com/NoahThomlison/react-mini-project",
    image: ["./projectImages&Gifs/Fullsize/MiniProject - Tours.gif?raw=true"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/MiniProject - Tours Small.gif"]
  },  
  {
    title: "MiniProject - Reviews",
    description: "Customer reviews are rendered from static data file into a carosel that can be rotated or display a random review", 
    techStack: ["React"],
    githubLink: "https://github.com/NoahThomlison/react-mini-project",
    image: ["./projectImages&Gifs/Fullsize/MiniProject - Reviews.gif?raw=true"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/MiniProject - Reviews Small.gif"]
  },  
  {
    title: "MiniProject - Accordion",
    description: "Creates a Q&A accordian, from static data, which can be expanded and collapsed on button click.", 
    techStack: ["React"],
    githubLink: "https://github.com/NoahThomlison/react-mini-project",
    image: ["./projectImages&Gifs/Fullsize/MiniProject - Accordion.gif?raw=true"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/MiniProject - Accordion Small.gif"]
  },  
  {
    title: "MiniProject - Menu",
    description: "Creates a menu from static data which can be sorted by various food categories", 
    techStack: ["React"],
    githubLink: "https://github.com/NoahThomlison/react-mini-project",
    image: ["./projectImages&Gifs/Fullsize/MiniProject - Menu.gif?raw=true"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/MiniProject - Menu Small.gif"]
  },
  {
    title: "MiniProject - Turtle OOP Snake",
    description: "Creates a python version of Snake using TKinter and OOP", 
    techStack: ["Python"],
    githubLink: "https://noahthomlison.github.io/100-days-of-python/",
    image: ["./projectImages&Gifs/Fullsize/turtleSnake.gif?raw=true"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/turtleSnake.gif"]
  },
  {
    title: "MiniProject - Quizler",
    description: "A Python quiz application which pulls questions from external API", 
    techStack: ["Python", "API"],
    githubLink: "https://noahthomlison.github.io/100-days-of-python/",
    image: ["./projectImages&Gifs/Fullsize/quizler.gif?raw=true"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/quizler.gif"]
  },
  {
    title: "MiniProject - Learn French Flip Cards",
    description: "Flip card program to learn new language, writes missed words to file to reshow", 
    techStack: ["Python",],
    githubLink: "https://noahthomlison.github.io/100-days-of-python/",
    image: ["./projectImages&Gifs/Fullsize/frenchCards.gif?raw=true"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/frenchCards.gif"]
  },
  {
    title: "MiniProject - Turtle Race",
    description: "Project to use TKinter to create a turtle racing game", 
    techStack: ["Python",],
    githubLink: "https://noahthomlison.github.io/100-days-of-python/",
    image: ["./projectImages&Gifs/Fullsize/turtleRace.gif?raw=true"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/turtleRace.gif"]
  },
  {
    title: "MiniProject - Python Pong",
    description: "Renders classic Pong game for 2 players using OOP and TKinter", 
    techStack: ["Python",],
    githubLink: "https://noahthomlison.github.io/100-days-of-python/",
    image: ["./projectImages&Gifs/Fullsize/turtlePong.gif?raw=true"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/turtlePong.gif"]
  },
  {
    title: "MiniProject - Python Frogger",
    description: "Renders classic Frogger game", 
    techStack: ["Python",],
    githubLink: "https://noahthomlison.github.io/100-days-of-python/",
    image: ["./projectImages&Gifs/Fullsize/turtleFrogger.gif?raw=true"],
    thumbnail: ["../projectImages&Gifs/Thumbnail/turtleFrogger.gif"]
  },
]